import Vue from 'vue';
import App from './App.vue';
import VueI18n from 'vue-i18n';
import router from './router';
import store from './store';
import less from 'less';
// import storage from './utils/storage';

// 引入rem.js
import './utils/rem'

// 引入公共样式
import './assets/css/reset.css';
import './assets/css/publice.css';
import './assets/css/iconfont.css';

// 引入vant
import './lib/element';
import 'element-ui/lib/theme-chalk/index.css';

// 注册插件
Vue.use(VueI18n);
Vue.use(less);

// 语言配置
const messages = {
  en: require('./language/en.json'),
  cn: require('./language/cn.json'),
  rus: require('./language/rus.json'),
  vnm: require('./language/vnm.json'),
  // 可以添加其他语言的 json 文件
};


// 创建 VueI18n 实例
const i18n = new VueI18n({
  locale: store.state.language, // 从 Vuex store 中获取语言设置
  messages,
});

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  router,
  store,
  i18n,
}).$mount('#app');
